export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL as string;
export const APP_BASE_URL = import.meta.env.VITE_APP_BASE_URL as string;
